export default __webpack_public_path__ + "static/media/old-chair.d889348b.png";